import React, { useState } from 'react';

import { initialFormValues, warehouseLocationSchema, type WarehouseLocationFormattedData } from '../../schemas';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { ViTriKho, ViTriKhoInput } from '@/types/schemas/vi-tri-kho.type';
import WarehouseLocationForm from './WarehouseLocationForm';
import { FormMode } from '@/types/form';

interface WarehouseSelection {
  uuid: string;
  ma_kho: string;
  ten_kho: string;
}

interface WarehouseLocationDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: ViTriKho | null;
  onClose: () => void;
  onSubmit?: (data: ViTriKhoInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onWatchButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const WarehouseLocationDialog: React.FC<WarehouseLocationDialogProps> = ({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}) => {
  const [kho, setKho] = useState<WarehouseSelection | null>(initialData?.ma_kho_data || null);

  const handleSubmit = async (data: WarehouseLocationFormattedData) => {
    onSubmit?.({ ...data, ma_kho: kho?.uuid || null } as ViTriKhoInput);
  };
  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem chi tiết';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2<WarehouseLocationFormattedData>
          mode={mode}
          hasAritoActionBar={false}
          schema={warehouseLocationSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialFormValues) as Partial<WarehouseLocationFormattedData>}
          className='w-full md:min-w-[500px] lg:min-w-[800px]'
          headerFields={<WarehouseLocationForm mode={mode} kho={kho} setKho={setKho} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default WarehouseLocationDialog;
